var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.skipDelayCountNum>0),expression:"skipDelayCountNum>0"}],staticClass:"skip-delay-count"},[_vm._v(_vm._s(_vm.skipDelayCountNum)+"s")])}
var staticRenderFns = []

export { render, staticRenderFns }